import React from 'react';
function Skills() {
    return (
      <div className="skills">
        <h1>My Skills</h1>
  
        <p>HTML</p>
        <div class="container">
         <b><div class="skills html">90%</div></b> 
        </div>
  
        <p>CSS</p>
        <div class="container">
          <b></b><div class="skills css">80%</div>
        </div>
  
        <p>JavaScript</p>
        <div class="container">
        <b><div class="skills js">75%</div></b>
        </div>

        <p>Tailwind</p>
        <div class="container">
        <b><div class="skill Tailwind">75%</div></b> 
        </div>

        <p>React</p>
        <div class="container">
        <b><div class="skills React">70%</div></b>
        </div>

        <p>Next.js</p>
        <div class="container">
        <b><div class="skills Next">65%</div></b>
        </div>

        <p>Node.js</p>
        <div class="container">
        <b><div class="skills Node">65%</div></b>
        </div>
        <a href="./assests/resume.pdf" target="blank" class="block m-10 text-center">
    <b><button class="flex items-center justify-center bg-orange-500 text-black rounded-full px-4 py-2">Resume</button></b>
  </a>
  
      </div>
    );
  }
  export default Skills;
  